import React from "react";

const CLASS_BY_TYPE = {
  horizontal: "mt-1 flex gap-[3px] w-full",
  default: "mt-3",
};

const ReportChart = ({reportInfo, type = "default", limit = null, dataLength = null, divisor = true, wrapperClassName= "", hasTotal = false, totalQty}) => {
  const showTop = limit && dataLength && dataLength >= limit;
  return (
    <>
      <div className={[wrapperClassName, "chart-report relative"].join(" ")}>
        { hasTotal &&
          <span className="text-[14px] right-1 leading-[20px] absolute font-bold">Total: {totalQty}</span>
        }
        <span className="chart-title">{reportInfo.reportName}{!!showTop && ` (TOP ${limit})`}</span>
        <div className={CLASS_BY_TYPE[type]} id={reportInfo.reportId}></div>
      </div>
      {divisor && <div className="chart-divisor"></div>}
    </>
  );
};

export default ReportChart;